/* eslint-disable no-unused-vars */
import Vue from 'vue';

function isAuth() {
  // if (Vue.ls.get('token', null) != null) {
  if (Vue.$cookies.get("token")!= null) {
    return true;
  } else {
    return false;
  }
}

function loadAccount() {
  console.log("utils load account");
  //return [Vue.ls.get('ubn',null),Vue.ls.get('email',null)];
  // let ubn = Vue.ls.get('ubn', null);
  let email = Vue.ls.get('email', null);
  return {
    // ubn: ubn,
    email: email
  };
  // return {
  //   ubn: Vue.ls.get('ubn',null),
  //   email: Vue.ls.get('email',null)
  // };
}

function rememberAccount(user) {
  // Vue.ls.set('ubn', user.ubn);
  Vue.ls.set('email', user.email);
}

function clearAccount() {
  // Vue.ls.remove('ubn');
  Vue.ls.remove('email');
}

function login(user) {
  Vue.$cookies.set("token",user.token,"0");
  Vue.$cookies.set("name",user.name,"0");
  Vue.$cookies.set('roles', user.roles,"0");
}

function logOut() {
  Vue.$cookies.remove("token");
  Vue.$cookies.remove("name");
  Vue.$cookies.remove('roles');
  Vue.router.replace({
    name: "Login"
  });
}

/** 此帳號否有此權限 */
function hasRole(rolesList) {
  let roles = Vue.$cookies.get('roles');
  if (rolesList == undefined) return true;
  return rolesList.find(role => {
    return roles.includes(role);
  }) !== undefined;
}


export default {
  isAuth,
  loadAccount,
  rememberAccount,
  clearAccount,
  login,
  logOut,
  hasRole,
};
